import React, { useState, useEffect } from "react";
import Header from "./Header";
import { Link, useNavigate } from "react-router-dom";
import apiService from '../Services/apiService';
import '../styles/SurveyList.css';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
const SurveyList = () => {
  const [UserDetails, setUserDetails] = useState(null);
  const [surveyDetails, setSurveyDetails] = useState([]);
  const [activeTab, setActiveTab] = useState("active");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDays, setSelectedDays] = useState("Last 3 Days");
  const [surveyCounts, setSurveyCounts] = useState(0);
  const [SurveyResponseRate, setSurveyResponseRate] = useState(0);
  const [surveyData, setsurveyData] = useState([]);
  const [PlanData, setPlanData] = useState([]);
  const [ProfileData, setProfileData] = useState([]);
  const navigate = useNavigate();

  // Fetch user details from API
  useEffect(() => {
    const token = localStorage.getItem("JWTToken");
    if (token) {

      const fetchUserDetails = async () => {
        if (token) {
          try {
            const response = await apiService.EncryptJWT(token);
            if (response) {
              setUserDetails(response); // Update state
            }
          } catch (error) {
            console.error("Error fetching user details:", error);
          }
        } else {
          navigate("/Login");
        }
      };
      // Fetch survey details from API
      const fetchSurveyDetails = async () => {
        if (token) {
          try {
            const response = await apiService.GetSurveyDetails(token);
            if (response) {
              setSurveyDetails(response.SURVEY_DETAILS);
            }
          } catch (error) {
            console.error("Error fetching survey details:", error);
          }
        } else {
          navigate("/Login");
        }
      };
      const FetchSurveyRateData = async () => {
        const response = await apiService.GetSurveyResponseRate(token);
        if (response) {
          console.log(response);
          if (response && response.SURVEY_DETAILS) {
            setsurveyData(response.SURVEY_DETAILS);
          }

        }
      }
      const GetPlanDetailsUser = async () => {
        if (token) {
          try {
            const response = await apiService.GetPlanDetailsUser(token);
            if (response) {
              if (response.RESPONSE[0]) {
                setPlanData(response.RESPONSE[0])
                console.log(response.RESPONSE[0]);
              }
            }
          } catch (error) {
            console.error("Error fetching user details:", error);
          }
        } else {
          navigate("/Login");
        }
      }
      const GetUserProfile = async () => {
        if (token) {
          debugger;
          try {
            const response = await apiService.GetUserProfileData(token);
            if (response) {
                setProfileData(response.USER_DETAILS[0])
                console.log(response.USER_DETAILS);
            }
          } catch (error) {
            console.error("Error fetching user details:", error);
          }
        } else {
          navigate("/Login");
        }
      };
      fetchUserDetails();
      fetchSurveyDetails();
      FetchSurveyRateData();
      GetPlanDetailsUser();
      GetUserProfile();
    } else {
      navigate("/Login");
    }

  }, [navigate]);

  // Update localstorage when UserDetails is fetched
  useEffect(() => {
    if (UserDetails) {
      const { Name, RoleID, ProfileImageUrl, UserType } = UserDetails?.RESPONSE || {};
      localStorage.setItem("UserName", Name);
      localStorage.setItem("ProfileUrl", ProfileImageUrl);
      localStorage.setItem("RoleID", RoleID);
      localStorage.setItem("UserType", UserType);
      setLoading(false);
    } else {

    }
  }, [UserDetails, loading]);

  const categorizedSurveys = {
    active: surveyDetails.filter(survey => survey.Status === "Active"),
    completed: surveyDetails.filter(survey => survey.Status === "Survey Ended"),
    draft: surveyDetails.filter(survey => survey.Status === "Incomplete"),
    Inactive: surveyDetails.filter(survey => survey.Status === "Inactive"),
    Scheduled: surveyDetails.filter(survey => survey.Status === "Scheduled to start"),
  };

  // Filter surveys by search term for the active tab
  const filteredSurveys = categorizedSurveys[activeTab]?.filter((survey) =>
    survey.SurveyName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Tab switch handler
  const handleTabChange = (tab) => setActiveTab(tab);

  // Survey Card Component
  const SurveyCard = ({ survey }) => (
    <Link to={`/ManageSurvey/${survey.UniqueKey}`}>
      <div className="card Box m-2 p-3 shadow-sm" style={{ width: "10rem", height: "14rem" }}>
        <p className="card-text">Ending: {survey.SurveyEndDateTime || "N/A"}</p>
        <div className="card-body p-0 d-flex flex-column justify-content-between">
          <h6 className="card-title fw-bold">
            {survey.SurveyName.length > 40
              ? `${survey.SurveyName.slice(0, 40)}...`
              : survey.SurveyName}
          </h6>
          <div className="row">
            <div className="col-10"> 

          <p className="card-text">{survey.TotalQuestions} Questions</p>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
  useEffect(() => {
    if (surveyData.length > 0 && selectedDays) {
      updateSurveyCount(selectedDays);
    }
  }, [surveyData, selectedDays]);

  const updateSurveyCount = (TimePeriod) => {
    const selectedSurvey = surveyData.find((survey) => survey.TimePeriod === TimePeriod);
    setSurveyCounts(selectedSurvey ? selectedSurvey.SurveyPublished : 0);
    setSurveyResponseRate(selectedSurvey ? parseFloat(selectedSurvey.ResponseRate).toFixed(2) : "0.00");
  };
  const formatDate = (date) => {
    if (!date) return "Invalid Date"; // Handle null case

    const year = date.getFullYear();
    const month = date.toLocaleString('en-US', { month: 'short' }); // Get short month name (e.g., Jan, Feb, Mar)
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two-digit day

    return `${day}-${month}-${year}`; // Format as DD-MMM-YYYY
  };

  const parseDateString = (dateString) => {
    const parsedDate = new Date(dateString); // Convert to Date object
    if (isNaN(parsedDate)) {
      console.error(`Invalid date string: ${dateString}`);
      return null; // Return null if invalid
    }
    return parsedDate;
  };
  return (
    <>
      <Header />
      <div className="container-fuild bg-Truvey py-5">
        <div className="container">
          <div className="row justify-content-evenly">
            <div className="Box p-4" style={{ minHeight: "200px", maxWidth: "350px" }}>
              <div>
                <h5 className="text-lg font-bold text-black">Profile</h5>
              </div>
              <div className="mt-3 d-flex justify-content-evenly">
                <div className="flex-wrap items-center justify-center Rounded-profile">
                {
                  Object.keys(ProfileData).length > 0 ? (<>
                    <p className="w-4/5 text-center text-xl font-semibold text-green-100">{ProfileData.ProfileCompletionPercentage}%</p>
                    <p className="w-4/5 text-center text-xs text-black opacity-60">Completed</p>
                  </>) : ("")
                }
                </div>
                <div className="flex w-50 p-3 align-items-center justify-center text-right">
                  <div className="inline-block text-center">
                    <p>+5% export the first report</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="Box p-4" style={{ minHeight: "200px", maxWidth: "350px" }}>
              <div className="text-end">
                <select
                  name="daysDropdown"
                  id="daysDropdown"
                  className="DaysDropdown"
                  value={selectedDays}
                  onChange={(e) => setSelectedDays(e.target.value)}
                >
                  {surveyData.map((survey, index) => (
                    <option key={index} value={survey.TimePeriod}>
                      {survey.TimePeriod}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mt-3 d-flex justify-content-evenly">
                <div className="flex-wrap items-center justify-center">
                  <span>Survey Publish</span>
                  <p><b>{surveyCounts}</b></p>


                </div>
                <div className="flex w-50 align-items-center justify-center text-right">
                  <div className="inline-block text-center">
                    <span>Response rate</span>
                    <p><b>{SurveyResponseRate}%</b></p>
                  </div>
                </div>
              </div>
            </div>
            <div className="Box p-4" style={{ minHeight: "200px", maxWidth: "350px" }}>
              <div>
                {
                  Object.keys(PlanData).length > 0 ? (<>
                    <i className="fa-solid fs-12 fa-indian-rupee-sign Gold"></i> {PlanData.PlanTire} ({PlanData.PlanType})
                  </>) : ""
                }
              </div>
              <div className="mt-3 row align-items-center">
                {/* <div className="col-6">
                  <span>Due Amount</span>
                  <p><b>INR 0</b></p>
                </div> */}
                {
                  Object.keys(PlanData).length > 0 ? (<>
                    <div className="col-6">Survey per month: <p><b>{PlanData.SurveyPerMonth}</b></p></div>
                    <div className="col-12 d-flex gap-2">Responders per month: <p><b>{PlanData.ResponderPerMonth}</b></p></div>
                  </>) : (<>
                    <div className="col-6">No active plan.</div>
                  </>)
                }
              </div>
              {
                Object.keys(PlanData).length > 0 ? (<>
                  <div>
                    <i className="Truveytext">Reset on {PlanData.ValidTill ? formatDate(parseDateString(PlanData.ValidTill)) : "Null"}</i>
                  </div>
                </>) : ("")
              }
            </div>
          </div>
        </div>
        <div className="container py-4">
          {/* Tabs for switching between survey categories */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="nav nav-tabs">
              <button
                className={`nav-link ${activeTab === "active" ? "active" : ""}`}
                onClick={() => handleTabChange("active")}
              >
                Active Survey
              </button>
              <button
                className={`nav-link ${activeTab === "Scheduled" ? "active" : ""}`}
                onClick={() => handleTabChange("Scheduled")}
              >
                Scheduled
              </button>
              <button
                className={`nav-link ${activeTab === "completed" ? "active" : ""}`}
                onClick={() => handleTabChange("completed")}
              >
                Completed
              </button>
              <button
                className={`nav-link ${activeTab === "Inactive" ? "active" : ""}`}
                onClick={() => handleTabChange("Inactive")}
              >
                Inactive
              </button>
              <button
                className={`nav-link ${activeTab === "draft" ? "active" : ""}`}
                onClick={() => handleTabChange("draft")}
              >
                Draft
              </button>
            </div>
            <input
              type="text"
              placeholder="Search..."
              className="form-control w-25"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Loading State */}
          {loading ? (
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div className="d-flex flex-wrap align-items-center">
              <Link to={"/Survey/CreateNew"}>
                <div className="card TruveyBG Box m-2 p-3 shadow-sm" style={{ width: "10rem", height: "14rem" }}>
                  <div className="card-body p-0 d-flex flex-column justify-content-center align-item-center text-center">
                    <h6 className="card-title fw-bold text-white">New Survey</h6>
                  </div>
                </div>
              </Link>
              {filteredSurveys?.length > 0 ? (
                filteredSurveys.map(survey => (
                  <SurveyCard key={survey.SurveyID} survey={survey} />
                ))
              ) : (
                <p className="text-muted">No surveys available in this category.</p>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SurveyList;
